export enum SegmentProvisionType {
  TEMPORARY = 'temporary',
  PERMANENT = 'permanent',
}

export enum BigSegmentUploadMode {
  REPLACE = 'replace',
  MERGE = 'merge',
}

export enum SegmentSourceType {
  RULES = 'rules',
  LIST = 'list',
  SYNC = 'sync',
}
